/**
 * OCR Service Configuration
 * Sourced directly from OWNER_INPUTS.md
 */

export interface OCRConfig {
  apiUrl: string;
  directApiUrl: string;
  payload: {
    format: string;
    imageField: string;
    encodingPrefix: string;
  };
  capabilities: string[];
  responseFormat: {
    httpCode: number;
    responseField: string;
    nestedTextField: string;
    successField: string;
  };
  limits: {
    maxFileSizeBytes: number;
    timeoutMs: number;
    maxRetries: number;
  };
}

export const OCR_CONFIG: OCRConfig = {
  // Use /api/ocr proxy route (handled by Vite proxy locally and Cloudflare Pages Functions in production)
  apiUrl: '/api/ocr',
  directApiUrl: 'https://ai-service-prod.compscilib.com/image-to-text',
  
  payload: {
    format: 'application/json',
    imageField: 'image',
    encodingPrefix: 'data:image/png;base64,',
  },

  capabilities: [
    'structured text',
    'mathematical formulas',
    'data tables',
  ],

  responseFormat: {
    httpCode: 200,
    responseField: 'response',
    nestedTextField: 'text',
    successField: 'success',
  },

  limits: {
    maxFileSizeBytes: 10 * 1024 * 1024, // 10MB
    timeoutMs: 30000,                  // 30 seconds
    maxRetries: 2,
  },
};
